import React, { Suspense, lazy } from 'react';
import Css from './App.module.css';
// import Footer from './component/Footer/Footer';
// import Header from './component/Header/Header';
import { Route, Routes } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Error404 from './component/Error404/Error404';
import Spiner from './component/Loader/Spiner/Spiner';

const DisplayComponent = lazy(() => import('./component/Display/DisplayComponent'))
const IndexOrganzaFiltr = lazy(() => import('./component/Display/IndexOrganza/IndexOrganzaFiltr'))
const ItemOrganzaContainer = lazy(() => import('./component/Display/Item/ItemOrganzaContainer'))

const theme = createTheme({
  components: {
    // Name of the component
    MuiList: {
      styleOverrides: {
        // Name of the slot
        root: {
          // Some CSS
        },
      },
    },
  },
  list: {

  }
});

// console.log(process.env)

function App(props) {

  return (
    <ThemeProvider theme={theme}>
      <div className={Css.content}>
        {/* <Header/> */}
        {/* Hi {process.env.REACT_APP_NAME} */}
        <Routes>
          <Route exact path="/" element={<Suspense fallback={<Spiner />}><IndexOrganzaFiltr /></Suspense>} />
          <Route path="/catalog/" element={<Suspense fallback={<Spiner />}><DisplayComponent /></Suspense>} />
          <Route path="/:itemcodurl/" element={<Suspense fallback={<Spiner />}><ItemOrganzaContainer /></Suspense>} />
          <Route path="*" element={<Error404 />} />
        </Routes>
        {/* <Footer/> */}
      </div>
    </ThemeProvider>
  );
}

export default App;
